module.exports = __webpack_public_path__ + "media/images/Speak-a253d1c2.png";